import { FirebaseConfig } from '../../config/config';
export var global = {
    urlService      : FirebaseConfig.functionsURL + '/websiteRequestInformation',
    urlServiceEmail :  FirebaseConfig.functionsURL + '/websiteSendMail'
};